import { render, staticRenderFns } from "./planTable.vue?vue&type=template&id=224121c1&"
import script from "./planTable.vue?vue&type=script&lang=js&"
export * from "./planTable.vue?vue&type=script&lang=js&"
import style0 from "./planTable.vue?vue&type=style&index=0&id=224121c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports